import gql from "graphql-tag";

export const QUERY_USER_BY_AUTH_ID = gql`
  query fetchUserByAuthId($authId: String!) {
    __typename
    user(where: { authId: { _eq: $authId } }) {
      email
      id
      name
      team_id
      hospital_id
    }
  }
`;
